<template>
  <v-btn
    flat
    class="text-secondary"
    @click="dialog=true"
  >
    {{ $t('ChangePassword.Title') }}
  </v-btn>

  <SimpleCardDialog
    v-model:dialog="dialog"
    max-width="450"
    show-cancel
    :title="$t('ChangePassword.Title')"
  >
    <form>
      <PasswordInput
        v-model="pw.current"
        required
        :label="$t('ChangePassword.CurrentPassword')"
        :field-key="fieldKey('current')"
        autocomplete="off"
      />
      <PasswordInput
        v-model="pw.new"
        required
        :label="$t('ChangePassword.NewPassword')"
        :field-key="fieldKey('new')"
        autocomplete="off"
      />
    </form>
    <v-alert
      type="info"
      :value="true"
    >
      {{ $t('ChangePassword.LogoutAfterChange') }}
    </v-alert>

    <template #actions>
      <ActionButton
        save
        @click="changePassword()"
      />
    </template>
  </SimpleCardDialog>
</template>

<script>
  import FormMixin from '@/components/forms/FormMixin'
  import * as logout from '../../library/logout'
  import SimpleCardDialog from '@/components/parts/dialog/SimpleCardDialog'
  import ActionButton from '@/components/parts/button/ActionButton'
  import PasswordInput from '@/components/parts/inputs/PasswordInput'

  export default {
    components: {
      PasswordInput,
      ActionButton,
      SimpleCardDialog
    },
    mixins: [FormMixin],
    data: () => ({
      pw: {
        current: null,
        new: null
      },
      dialog: false
    }),
    methods: {
      changePassword () {
        this.$http.put('change-password/', this.pw).then((res) => {
          logout.thisSession()
        })
      }
    }
  }
</script>

<style scoped>

</style>
